import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { AddEventIcon } from "@/assets/widgets/add-event-icon.tsx"
import { useGetAllCropPlantingEventsQuery } from "@/features/events/crop-planting-events/api/crop-planting-events-api.ts"
import { CropPlantingEventCard } from "@/features/events/crop-planting-events/components/crop-planting-event-card/crop-planting-event-card.tsx"
import {
  CROP_PLANTING_EVENT_LIST_VIEW,
  NEW_CROP_PLANTING_EVENT_VIEW,
} from "@/features/events/crop-planting-events/routes/route-list.ts"
import EmptyContentCreateItemButton from "@/features/home/components/empty-content-create-item-button/empty-content-create-item-button.tsx"
import WidgetHeader from "@/features/home/components/widget-header/widget-header.tsx"

interface Props {
  cropPlantingId?: string
}

export const CropPlantingEventsSummaryWidget: React.FC<Props> = ({
  cropPlantingId,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: events = [] } = useGetAllCropPlantingEventsQuery()

  const workingEvents = cropPlantingId
    ? events.filter((event) => event.crop_planting === cropPlantingId)
    : events

  const newEventString =
    NEW_CROP_PLANTING_EVENT_VIEW +
    (cropPlantingId ? `?cropPlantingId=${cropPlantingId}` : "")

  const addItemsGoToAction =
    workingEvents && workingEvents?.length > 0
      ? () => navigate(newEventString)
      : undefined

  return (
    <div
      className={
        "widget-border box-border flex w-full flex-col gap-5 bg-white px-4 py-4"
      }
    >
      <WidgetHeader
        title={t("cropPlantingEvents")}
        navigateTo={CROP_PLANTING_EVENT_LIST_VIEW}
        icon={<AddEventIcon />}
        addItemGoTo={addItemsGoToAction}
      />
      {workingEvents && workingEvents.length > 0 ? (
        <div className={"flex flex-col gap-2"}>
          {workingEvents.slice(0, 3).map((event, index) => (
            <CropPlantingEventCard cropPlantingEvent={event} key={index} />
          ))}
        </div>
      ) : (
        <EmptyContentCreateItemButton navigateTo={newEventString} />
      )}
    </div>
  )
}
